import {createRouter, createWebHistory} from 'vue-router';
import { auth } from '@/firebase';

/* ================= Beneva Mississauga  ================= */
import * as formPage1900 from "@/views/1900/form-page";
import * as photosPage1900 from "@/views/1900/photos-page";

/* ================= Midwinter Marathon ================= */
import * as formPage1724 from "@/views/1724/form-page";
import * as videosPage1724 from "@/views/1724/videos-page";

/* ================= Admin ================= */
import * as adminLoginPage from "@/views/admin/login-page";
import * as adminDashboardPage from "@/views/admin/dashboard-page";

/* ================= Schermen ================= */
import screenVideos from "@/views/screen/videos";
import screenPhotos from "@/views/screen/photos";

/* ====================================================== */

const routes = [
  {
    path: '/',
    redirect: '/1900/upload'
  },
  {
    path: '/midwinter',
    redirect: '/1724/videos'
  },
  {
    path: '/beneva-mississauga',
    redirect: '/1900/upload'
  },

  /* ================= Upload forms ================= */
  {
    path: '/1724/upload',
    component: formPage1724.default,
    meta: { title: 'Cheerzone - Midwinter upload' }
  },
  {
    path: '/1724/videos',
    component: videosPage1724.default,
    meta: { title: 'Cheerzone - Midwinter videos' }
  },
  {
    path: '/1900/upload',
    component: formPage1900.default,
    meta: { title: 'Cheerzone - Beneva Mississauga upload' }
  },
  {
    path: '/1900/photos',
    component: photosPage1900.default,
    meta: { title: 'Cheerzone - Beneva Mississauga fotos' }
  },

  /* ================= Admin ================= */
  {
    path: '/admin',
    component: adminLoginPage.default,
    meta: { title: 'Admin – Inloggen', hideWidget: true }
  },
  {
    path: '/admin/dashboard',
    component: adminDashboardPage.default,
    meta: { title: 'Admin – Dashboard', requiresAdmin: true, hideWidget: true }
  },

  /* ================= Schermen ================= */
  {
    path: '/screen/videos',
    component: screenVideos,
    meta: { title: 'Cheerzone – Video scherm', hideWidget: true }
  },
  {
    path: '/screen/photos',
    component: screenPhotos,
    meta: { title: 'Cheerzone – Foto scherm', hideWidget: true }
  },
  // Backwards compat
  {
    path: '/videos',
    redirect: '/screen/videos'
  },
  {
    path: '/photos',
    redirect: '/screen/photos'
  },
];

const router = new createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title

  if (to.path.startsWith('/screen')) {
    document.body.classList.add('screen-view');
  } else {
    document.body.classList.remove('screen-view');
  }

  if (to.meta.hideWidget) {
    document.body.classList.add('hide-widget');
  } else {
    document.body.classList.remove('hide-widget');
  }

  if (to.meta.requiresAdmin && process.env.NODE_ENV !== 'development') {
    const user = auth.currentUser;
    const isGoogleUser = user && !user.isAnonymous;
    if (!isGoogleUser) {
      return next('/admin');
    }
  }

  next();
})

export default router;
